// 入库路由


export default {
  path: "/inWarehouse",
  name: "inWarehouse",
  meta: { title: "入库管理", icon: "in-warehouse" },
  children: [
    {
      path: "/inWarehouse/standardInWarehouse",
      name: "standardInWarehouse",
      component: () => import(/* webpackChunkName: "standardInWarehouse" */'@/views/warehouse/inWarehouse/standardInWarehouse.vue'),
      meta: {title: "标准入库", icon: "standardInWarehouse"}
    },
    {
      path: "/inWarehouse/procureWarehouse",
      name: "procureWarehouse",
      component: () => import(/* webpackChunkName: "procureWarehouse" */'@/views/warehouse/inWarehouse/procureWarehouse.vue'),
      meta: {title: "采购入库", icon: "procureWarehouse"}
    },
    {
      path: "/inWarehouse/returnInWarehouse",
      name: "returnInWarehouse",
      component: () => import(/* webpackChunkName: "returnInWarehouse" */'@/views/warehouse/inWarehouse/returnInWarehouse.vue'),
      meta: {title: "退货入库", icon: "returnInWarehouse"}
    },
    {
      path: "/inWarehouse/allocationInWarehouse",
      name: "allocationInWarehouse",
      component: () => import(/* webpackChunkName: "allocationInWarehouse" */'@/views/warehouse/inWarehouse/allocationInWarehouse.vue'),
      meta: {title: "调拨入库", icon: "allocationInWarehouse"}
    },

  ]


}